import { render, staticRenderFns } from "./LootEnhancedItems.vue?vue&type=template&id=2d56d259&lang=pug&"
import script from "./LootEnhancedItems.vue?vue&type=script&lang=ts&"
export * from "./LootEnhancedItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports